import { SHIPPING_ON_THE_WAY_STATUSES } from '../constants/shipping';

export const checkOnTheWay = (order) =>
	SHIPPING_ON_THE_WAY_STATUSES.includes(order?.shipping?.status);
